const routers = [
    {
      // 打印入库票据
      path: '/printnote/list',
      name: 'printnote',
      component: () => import('@/views/modules/makebook/printnote/List.vue')
    },
    {
      // 打印出库票据
      path: '/printoutnote/list',
      name: 'printoutnote',
      component: () => import('@/views/modules/makebook/printoutnote/List.vue')
    },
    {
      // 成品移库
      path: '/productadjustment/list',
      name: 'productadjustment',
      component: () => import('@/views/modules/makebook/productadjustment/List.vue')
    },
    {
      // 汇总
      path: '/productsummary/list',
      name: 'productsummary',
      component: () => import('@/views/modules/makebook/productsummary/List.vue')
    },
    {
      // 不良品
      path: '/rejected/list',
      name: 'rejected',
      component: () => import('@/views/modules/makebook/rejected/List.vue')
    }
  ]
  export default routers
  